import { ClaimContext, ClaimType } from '../../types';

/**
 * Hook to determine if a banner message should be shown for order items in the Invoice Step in the new flow
 */
export function useOrderItemBannerMessage(
  claim: Pick<ClaimContext, 'type' | 'isMultiShipmentOrder' | 'isReturnShipment'>
) {
  const { type, isReturnShipment, isMultiShipmentOrder } = claim;

  if (type === ClaimType.WHOLE_DAMAGE || type === ClaimType.INVESTIGATION) {
    if (isMultiShipmentOrder) {
      return 'MULTI_SHIPMENT_ORDER_ITEMS_INFO_MESSAGE';
    }

    if (isReturnShipment) {
      return 'RETURN_SHIPMENT_ORDER_ITEMS_INFO_MESSAGE';
    }
  }

  return undefined;
}
